module.exports = __webpack_public_path__ + "img/house_blue.c19c15a1.png";